<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.machineId === undefined"
      :hideFilter="$route.query[pk + 'filter'] === undefined">

      <template v-slot:filter>
        <FilterPane :title="'filters'" :pk="pk">
          <template v-slot:filters-content>
            <DefaultLifeCycleFilterGroup :pk="pk"></DefaultLifeCycleFilterGroup>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list :pk="pk">
        <ListPane :getListMethod="getEmploymentListFromFilter" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="50" ref="ListPane"
          :dialog-trigger="dialogtrigger" :dialogItem="editItem" :dialog-method-config="dialogMethodConfig" :pk="pk"
          :dialog-readonly="EmploymentReadonly">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @click="setEditItem(item)"></ListItem>
          </template>

          <template v-slot:dialog-content="{ item, trigger, readonly }">
            <v-container class="px-4" v-if="item" :key="trigger">
              <v-row no-gutters>
                <v-col cols="12" class="mb-3">
                  <QTextField v-model="item.Id" :label="$t('servicesystem.common_objects.employment.id')"
                    :disabled="!item.creation || readonly" externaledit :rules="[requiredRule]">
                  </QTextField>
                </v-col>
                <v-col cols="12" class="mb-3">
                  <QTextField v-model="item.Name" :label="$t('servicesystem.common_objects.commonterms.name')"
                    externaledit :rules="[requiredRule]" :disabled="readonly">
                  </QTextField>
                </v-col>
                <v-col v-if="!item.creation" cols="12">
                  <QSwitchInput v-model="item.IsActive" :label="$t('servicesystem.common_objects.commonterms.active')"
                    externaledit :disabled="readonly">
                  </QSwitchInput>
                </v-col>
              </v-row>
            </v-container>
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import Layout from "@/views/layouts/PreviewableList.vue";
import ListItem from "@/views/admin/employment/EmploymentListItem.vue";
import DefaultLifeCycleFilterGroup from "@/components/DefaultLifeCycleFilterGroup.vue";

export default {
  name: "AdminEmploymentList",
  props: {},
  components: {
    ListPane,
    Layout,
    ListItem,
    FilterPane,
    DefaultLifeCycleFilterGroup,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "EMPL-",
      editItem: null,
      dialogtrigger: 1,
      dialogMethodConfig: {
        Create: {
          IsClientApiMethod: true,
          Name: 'createEmployment',
        },
        Change: {
          IsClientApiMethod: true,
          Name: 'changeEmployment',
        },
      },
    };
  },

  mounted() { },

  methods: {
    handleadded: (item) => this.$refs.ListPane.handleadded(item),
    handlechanged: (item) => this.$refs.ListPane.handlechanged(item),

    setEditItem(item) {
      this.dialogtrigger++;
      this.editItem = item || { creation: true, Id: null, Name: "", IsActive: true };
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          ActiveState: this.getQueryParam("filter-active", 0),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    externaltrigger() { return this.$store.state.triggerevents.previewTrigger; },
  },

  watch: {
    externaltrigger: function () { this.setEditItem(null); }
  },
};
</script>


<style lang='scss' scoped></style>

